export enum TipoJustificativaEnum {
  INJUSTIFICADA = 0,
  ABONO = 1,
  COMPENSACAO = 2,
  OUTROS = 3,
}
